import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthSessionService } from '../services/auth-session.service';

export const AuthUnauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const authSession = inject(AuthSessionService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        authSession.forceReloginAfterUnauthorized(req);
      }
      return throwError(() => error);
    })
  );
};
